import { UIHeading5 } from '@cian/ui-kit';
import * as React from 'react';

import styles from './InvestorDayStreamButton.css';
import icon from './assets/icon.svg';

interface IInvestorDayStreamButtonProps {
  link: string;
}

export const InvestorDayStreamButton: React.FC<IInvestorDayStreamButtonProps> = ({ link }) => {
  return (
    <a href={link} className={styles['button']} target="_blank" rel="noopener noreferrer">
      <img src={icon} alt="Трансляция Дня инвестора" width={16} height={16} />

      <UIHeading5 color="text-main-default">Трансляция Дня инвестора</UIHeading5>
    </a>
  );
};
